import { render } from "./CIS-Healthcare-Graphic-Footnote.vue?vue&type=template&id=25628812&scoped=true"
import script from "./CIS-Healthcare-Graphic-Footnote.vue?vue&type=script&lang=js"
export * from "./CIS-Healthcare-Graphic-Footnote.vue?vue&type=script&lang=js"

import "./CIS-Healthcare-Graphic-Footnote.vue?vue&type=style&index=0&id=25628812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25628812"]])

export default __exports__